import {
    AfterViewInit,
    ComponentRef,
    Directive,
    ElementRef,
    Injector,
    Renderer2,
    ViewContainerRef,
} from '@angular/core';
import { Icon } from '../../components/icon/icon.component';

/**
 * @deprecated Será removido em uma versão futura.
 * Usar <ai-field> e atribuir o Validators.required ao formControl passado ao ai-field.
 *
 */
@Directive({
    selector: '[aiRequiredFieldLabel]',
    standalone: true,
})
export class RequiredFieldLabelDirective implements AfterViewInit {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private viewContainerRef: ViewContainerRef,
        private injector: Injector,
    ) {}

    ngAfterViewInit(): void {
        const label = this.el.nativeElement;
        const text = label.textContent?.trim();

        if (text) {
            this.renderer.setProperty(label, 'textContent', '');
            const span = this.renderer.createElement('span');
            this.renderer.setProperty(span, 'textContent', text);

            const icon: ComponentRef<Icon> =
                this.viewContainerRef.createComponent(Icon, {
                    injector: this.injector,
                });
            icon.setInput('fontIcon', 'red_rectangle_icon');

            this.renderer.appendChild(label, span);
            this.renderer.appendChild(label, icon.location.nativeElement);
            this.renderer.addClass(label, 'label-required');
        }
    }
}
